import Top from './Top'
export default Top


// WEBPACK FOOTER //
// ./src/components/Top/index.js